/**
 * Рекурсивно форматирует числовые значения указанных ключей (например, total, amount)
 * в объекте или массиве с использованием русской локали (пробелы как разделитель тысяч, запятая как десятичная).
 *
 * @param {any} data - Входные данные (объект, массив или примитив)
 * @param {string[]} keysToFormat - Список ключей, значения которых нужно форматировать как числа
 * @returns {any} Новый объект/массив с отформатированными значениями
 *
 * @example
 * formatCurrencyValues({ total: 1234.56, name: 'test' })
 * // → { total: '1 234,56', name: 'test' }
 */

export const defaultKeysToFormat = {
  statClicks: {showDecimalIfZero: false},
  statImpressions: {showDecimalIfZero: false},
  statCpm: {showDecimalIfZero: true},
  statSpend: {showDecimalIfZero: true},
}

export const formatKeyValues = (data, keysToFormat = defaultKeysToFormat, globalShowDecimalIfZero = true) => {
  // Обратная совместимость: если keysToFormat — массив, преобразуем в объект
  if (Array.isArray(keysToFormat)) {
    keysToFormat = Object.fromEntries(
      keysToFormat.map((key) => [key, {showDecimalIfZero: globalShowDecimalIfZero}]),
    )
  }

  // Базовые типы — возвращаем как есть
  if (typeof data !== 'object' || data === null) {
    return data
  }

  // Обработка массива
  if (Array.isArray(data)) {
    return data.map((item) => formatKeyValues(item, keysToFormat, globalShowDecimalIfZero))
  }

  // Обработка объекта
  const result = {}

  for (const [key, value] of Object.entries(data)) {
    const keyConfig = keysToFormat[key]

    if (keyConfig && typeof value === 'number' && !isNaN(value)) {
      // с запятыми
      // result[key] = value.toLocaleString('ru-RU', {
      //   minimumFractionDigits: 2,
      //   maximumFractionDigits: 2,
      // })

      // Форматируем число: с пробелом как разделитель тысяч
      const showDecimalIfZero = keyConfig.showDecimalIfZero ?? globalShowDecimalIfZero
      result[key] = formatChartValue(value, showDecimalIfZero)
    } else if (typeof value === 'object' && value !== null) {
      result[key] = formatKeyValues(value, keysToFormat, globalShowDecimalIfZero)
    } else {
      result[key] = value
    }

    // Если как процент — возможно, стоит умножить на 100 и добавить %
    // if (key === 'statCtr') {
    //   result[key] = (value * 100).toFixed(2) + ' %'; // → "3,50 %"
    // }
  }

  return result
}

export const formatChartValue = (val, showDecimalIfZero = true) => {
  if (typeof val !== 'number') return val

  let formatted = val.toFixed(2)

  if (!showDecimalIfZero && formatted.endsWith('.00')) {
    formatted = formatted.slice(0, -3)
  }

  return formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}
